import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgbCarousel, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { MediumDTO, ThumbnailSize } from '../../services/api/api';
import { MediumViewerComponent } from '../controls/medium-viewer/medium-viewer.component';
import { AppEnvironment } from 'src/app/app.environment';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'sb-preview-tooltip',
  templateUrl: './sb-preview-tooltip.component.html',
  styleUrls: ['./sb-preview-tooltip.component.scss'],
  standalone: false,
})
export class SbPreviewTooltipComponent {
  @Input() previews: MediumDTO[];
  @Input() thumbnailSize: string = ThumbnailSize.M;
  @Input() customHeight: string;
  @Input() customWidth: string;
  @Input() hoverPreview: boolean = true;
  @Input() showFullOnClick: boolean = false;
  @Input() background: boolean = false;
  @Input() still: boolean = false;
  @Input() hideArrows: boolean = false;
  @Input() hideIndicators: boolean = false;
  @Input() autoplay: boolean = false;
  @Input() interval: number = 5000;

  @Output() slideShowOnHoverAction = new EventEmitter<any>();

  url(medium: MediumDTO): string {
    let path = null;
    if (medium?.stillImage) {
      path = this.sanitizer.bypassSecurityTrustStyle(
        'url(' + this.util.appendQueryParamToUrl(medium.stillImage as unknown as string, 'thumbnail=XS') + ')'
      );
    }
    if (AppEnvironment.SCREENSHOT_MODE) {
      path = 'url(' + AppEnvironment.EXAMPLE_IMAGE(medium.name) + ')';
    }
    return path;
  }

  constructor(
    private modal: NgbModal,
    public translate: TranslateService,
    private util: UtilService,
    private sanitizer: DomSanitizer
  ) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    this.onDoubleClick();
  }

  onDoubleClick() {
    if (this.showFullOnClick === true) {
      if (this.previews?.length > 0 && this.previews[0]?.id) {
        const modal = this.modal.open(MediumViewerComponent, { size: 'lg' });
        (modal.componentInstance as MediumViewerComponent).medium = this.previews[0];
        (modal.componentInstance as MediumViewerComponent).modalRef = modal;
      }
    }
  }
}
